import { MatchedRoute, Route } from "./router";

export type DCRouteData = {
  allowAnonymous?: boolean;
  allowShareholder?: boolean;
};

export const boardMemberRoutes = [
  {
    name: "board-member/dashboard",
    path: "/board-member/:orgNo",
  },
  {
    name: "board-member/articlesofassociation",
    path: "/board-member/:orgNo/articlesofassociation",
  },
  {
    name: "board-member/meeting",
    path: "/board-member/:orgNo/meetings/project/:projectId",
  },
  {
    name: "board-member/messaging",
    path: "/board-member/:orgNo/messaging",
  },
  {
    name: "board-member/archive",
    path: "/board-member/:orgNo/archive",
  },
  {
    name: "board-member/schedule",
    path: "/board-member/:orgNo/schedule/:view?/:year?/:month?",
  },
] as const satisfies Route<DCRouteData>[];

export const shareholderRoutes = [
  {
    name: "shareholder/dashboard-redirect",
    path: "/shareholder/:orgNo/:shareholderId",
    redirectTo: "/shareholder/:orgNo/:shareholderId/dashboard",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/dashboard",
    path: "/shareholder/:orgNo/:shareholderId/dashboard",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/articlesofassociation",
    path: "/shareholder/:orgNo/:shareholderId/articlesofassociation",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/archive",
    path: "/shareholder/:orgNo/:shareholderId/archive",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/messaging",
    path: "/shareholder/:orgNo/:shareholderId/messaging/:id?",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/schedule",
    path: "/shareholder/:orgNo/:shareholderId/schedule/:view?/:year?/:month?",
    data: { allowShareholder: true },
  },
  {
    name: "shareholder/details",
    path: "/shareholder/:orgNo/:shareholderId/:tab",
    data: { allowShareholder: true },
  },
] as const satisfies Route<DCRouteData>[];

export const adminRoutes = [
  {
    name: "admin/root",
    path: "/company/:orgNo",
  },
  {
    name: "admin/dashboard",
    path: "/company/:orgNo/dashboard",
  },
  {
    name: "admin/follow-up",
    path: "/company/:orgNo/follow-up",
    redirectTo: "/company/:orgNo/follow-up/signatures",
  },
  {
    name: "admin/follow-up/matters",
    path: "/company/:orgNo/follow-up/matters/:tab?",
  },
  {
    name: "admin/follow-up/signatures",
    path: "/company/:orgNo/follow-up/signatures/:signaturesTab?",
  },
  {
    name: "admin/follow-up/companyinfo",
    path: "/company/:orgNo/follow-up/company-info/:tab?",
  },
  {
    name: "admin/follow-up/shareholders",
    path: "/company/:orgNo/follow-up/shareholders/:tab?",
  },
  {
    name: "admin/search",
    path: "/company/:orgNo/search",
  },
  {
    name: "admin/articlesofassociation",
    path: "/company/:orgNo/articlesofassociation",
  },
  {
    name: "admin/articlesofassociation2",
    path: "/company/:orgNo/articlesofassociation2",
  },
  {
    name: "admin/edit-articlesofassociation",
    path: "/company/:orgNo/articlesofassociation/edit",
  },
  {
    name: "admin/power-of-attorney",
    path: "/company/:orgNo/power-of-attorney/:powerOfAttorneyTab?",
  },
  {
    name: "admin/power-of-attorney-details",
    path: "/company/:orgNo/power-of-attorney/:powerOfAttorneyId/details",
  },
  {
    name: "admin/ownership",
    path: "/company/:orgNo/ownership",
  },
  {
    name: "admin/ownership/list",
    path: "/company/:orgNo/ownership/list",
  },
  {
    name: "admin/roles",
    path: "/company/:orgNo/roles",
  },
  {
    name: "admin/role-details",
    path: "/company/:orgNo/role/:id/details",
  },
  {
    name: "admin/settings",
    path: "/company/:orgNo/settings/:menuItem?",
  },
  {
    name: "admin/shareholders-redirect",
    path: "/company/:orgNo/shareholders",
    redirectTo: "/company/:orgNo/shareholders/list", // TODO Need to forward querystring
  },
  {
    name: "admin/shareholders-list",
    path: "/company/:orgNo/shareholders/list",
  },
  {
    name: "admin/shareholders-edit",
    path: "/company/:orgNo/shareholders/edit",
  },
  {
    name: "admin/shareholder-details-redirect",
    path: "/company/:orgNo/shareholders/list/:id",
    redirectTo: "/company/:orgNo/shareholders/list/:id/overview",
  },
  {
    name: "admin/shareholder-details",
    path: "/company/:orgNo/shareholders/list/:id/:tab",
  },
  {
    name: "admin/import-shareholders",
    path: "/company/:orgNo/shareholders/import",
  },
  {
    name: "admin/share-classes",
    path: "/company/:orgNo/shareholders/classes",
  },
  {
    name: "admin/create-share-class",
    path: "/company/:orgNo/shareholders/classes/create",
  },
  {
    name: "admin/edit-share-class",
    path: "/company/:orgNo/shareholders/classes/:shareTypeId",
  },
  {
    name: "admin/contributions-overview",
    path: "/company/:orgNo/shareholders/contributions",
  },
  {
    name: "admin/contributions-log",
    path: "/company/:orgNo/shareholders/contributions/log",
  },
  {
    name: "admin/contribution-details",
    path: "/company/:orgNo/shareholders/contributions/log/:contributionId",
  },
  {
    name: "admin/register-contribution",
    path: "/company/:orgNo/shareholders/contributions/new/:contributionType",
  },
  {
    name: "admin/commitments-overview",
    path: "/company/:orgNo/shareholders/commitments",
  },
  {
    name: "admin/commitments-log",
    path: "/company/:orgNo/shareholders/commitments/log",
  },
  {
    name: "admin/commitment-deltails",
    path: "/company/:orgNo/shareholders/commitments/log/:commitmentId",
  },
  {
    name: "admin/register-commitment",
    path: "/company/:orgNo/shareholders/commitments/new/:commitmentType",
  },
  {
    name: "admin/transactions",
    path: "/company/:orgNo/shareholders/transactions",
  },
  {
    name: "admin/new-transaction",
    path: "/company/:orgNo/shareholders/transactions/new/:transactionType",
  },
  {
    name: "admin/transaction-details",
    path: "/company/:orgNo/shareholders/transactions/:id",
  },
  {
    name: "admin/edit-transaction",
    path: "/company/:orgNo/shareholders/transactions/:id/edit",
  },
  {
    name: "admin/shareholder-register-statement",
    path: "/company/:orgNo/shareholders/altinn",
  },
  {
    name: "admin/beneficial-owners",
    path: "/company/:orgNo/shareholders/beneficial-owners",
  },
  {
    name: "admin/new-beneficial-owner",
    path: "/company/:orgNo/shareholders/beneficial-owners/new",
  },
  {
    name: "admin/beneficial-owner-auth-callback",
    path: "/company/:orgNo/shareholders/beneficial-owners/submit",
  },
  {
    name: "admin/beneficial-owner-details",
    path: "/company/:orgNo/shareholders/beneficial-owners/:id",
  },
  {
    name: "admin/beneficial-owners-log-details",
    path: "/company/:orgNo/shareholders/beneficial-owners/log/:statementId/:beneficialOwnerId?",
  },
  {
    name: "admin/project-list", // this to be removed when "project-dashboard" is activated in prod
    path: "/company/:orgNo/projects",
  },
  {
    name: "admin/dbot",
    path: "/company/:orgNo/dbot/:subMenuLink/:menuItem?",
  },
  {
    name: "admin/project",
    path: "/company/:orgNo/projects/:projectId",
  },
  {
    name: "admin/board-meeting-preview",
    path: "/company/:orgNo/board-meeting-preview/:projectId",
  },
  {
    name: "admin/general-meeting-preview",
    path: "/company/:orgNo/general-meeting-preview/:projectId/:tab?",
  },
  {
    name: "admin/messaging",
    path: "/company/:orgNo/messaging",
  },
  {
    name: "admin/archive",
    path: "/company/:orgNo/archive/:rootFolder?",
  },
  {
    name: "admin/schedule",
    path: "/company/:orgNo/schedule/:view?/:year?/:month?",
  },
] as const satisfies Route<DCRouteData>[];

export const superadminRoutes = [
  {
    name: "superadmin",
    path: "/super-admin-backoffice/:view?/:subView?",
  },
] as const satisfies Route<DCRouteData>[];

export const storiesRoutes = [
  {
    name: "stories",
    path: "/stories/:story?",
    data: { allowAnonymous: true },
  },
] as const satisfies Route<DCRouteData>[];

export const userRoutes = [
  {
    name: "root/redirect",
    path: "/",
    redirectTo: "/portfolio/all/companies",
  },
  {
    name: "portfolio/redirect",
    path: "/portfolio",
    redirectTo: "/portfolio/all/companies",
  },
  {
    name: "portfolio/companies-redirect",
    path: "/portfolio/companies",
    redirectTo: "/portfolio/all/companies",
  },
  {
    name: "help-center",
    path: "/help-center",
  },
  {
    name: "portfolio/help-center-all",
    path: "/portfolio/all/help-center",
  },
  {
    name: "portfolio/help-center-admin",
    path: "/portfolio/admin/help-center",
  },
  {
    name: "portfolio/help-center-board-member",
    path: "/portfolio/board_member/help-center",
  },
  {
    name: "portfolio/help-center-shareholder",
    path: "/portfolio/shareholder/help-center",
  },
  {
    name: "portfolio/instance-help-center",
    path: "/portfolio/:portfolioId/help-center",
  },
  // TODO Rewrite portfolio routes
  {
    name: "portfolio/companies-all",
    path: "/portfolio/all/companies/:tab?",
    data: { allowShareholder: true },
  },
  {
    name: "portfolio/companies-admin",
    path: "/portfolio/admin/companies/:tab?",
    data: { allowShareholder: true },
  },
  {
    name: "portfolio/companies-board-member",
    path: "/portfolio/board_member/companies/:tab?",
    data: { allowShareholder: true },
  },
  {
    name: "portfolio/companies-shareholder",
    path: "/portfolio/shareholder/companies/:tab?",
    data: { allowShareholder: true },
  },
  {
    name: "portfolio/companies-instance",
    path: "/portfolio/:portfolioId/companies/:tab?",
  },
  {
    name: "portfolio/follow-up-signatures-all",
    path: "/portfolio/all/follow-up/signatures/:signaturesTab?",
  },
  {
    name: "portfolio/follow-up-matters-all",
    path: "/portfolio/all/follow-up/matters/:tab?",
  },
  {
    name: "portfolio/follow-up-companyinfo-all",
    path: "/portfolio/all/follow-up/company-info/:tab?",
  },
  {
    name: "portfolio/follow-up/shareholders",
    path: "/portfolio/all/follow-up/shareholders/:tab?",
  },
  {
    name: "portfolio/follow-up-signatures-admin",
    path: "/portfolio/admin/follow-up/signatures/:signaturesTab?",
  },
  {
    name: "portfolio/follow-up-matters-admin",
    path: "/portfolio/admin/follow-up/matters/:tab?",
  },
  {
    name: "portfolio/follow-up-companyinfo-admin",
    path: "/portfolio/admin/follow-up/company-info/:tab?",
  },
  {
    name: "portfolio/follow-up-shareholders-admin",
    path: "/portfolio/admin/follow-up/shareholders/:tab?",
  },
  {
    name: "portfolio/follow-up-signatures-board-member",
    path: "/portfolio/board_member/follow-up/signatures/:signaturesTab?",
  },
  {
    name: "portfolio/follow-up-signatures-shareholder",
    path: "/portfolio/shareholder/follow-up/signatures/:signaturesTab?",
  },
  {
    name: "portfolio/follow-up-signatures-instance",
    path: "/portfolio/:portfolioId/follow-up/signatures/:tab?",
  },
  {
    name: "portfolio/follow-up-matters-instance",
    path: "/portfolio/:portfolioId/follow-up/matters/:tab?",
  },
  {
    name: "portfolio/follow-up-companyinfo-instance",
    path: "/portfolio/:portfolioId/follow-up/company-info/:tab?",
  },
  {
    name: "portfolio/follow-up-shareholders-instance",
    path: "/portfolio/:portfolioId/follow-up/shareholders/:tab?",
  },
  {
    name: "portfolio/contacts-all",
    path: "/portfolio/all/contacts/:contactsTab?",
  },
  {
    name: "portfolio/contacts-admin",
    path: "/portfolio/admin/contacts/:contactsTab?",
  },
  {
    name: "portfolio/contacts-board-members-redirect",
    path: "/portfolio/board_member/contacts/:contactsTab?",
    redirectTo: "/portfolio/board_member/companies",
  },
  {
    name: "portfolio/contacts-board-members-custom-role-redirect",
    path: "/portfolio/board_member/contacts/custom-role/:contactsTab?",
    redirectTo: "/portfolio/board_member/companies",
  },
  {
    name: "portfolio/contacts-shareholder-redirect",
    path: "/portfolio/shareholder/contacts/:contactsTab?",
    redirectTo: "/portfolio/shareholder/companies",
  },
  {
    name: "portfolio/contacts-shareholder-custom-role-redirect",
    path: "/portfolio/shareholder/contacts/custom-role/:contactsTab?",
    redirectTo: "/portfolio/shareholder/companies",
  },
  {
    name: "portfolio/contacts-instance",
    path: "/portfolio/:portfolioId/contacts/:contactsTab?",
  },
  {
    name: "portfolio/shareholder-redirect",
    path: "/portfolio/:portfolio/shareholder/:shareholderId",
    redirectTo: "/portfolio/:portfolio/shareholder/:shareholderId/overview",
  },
  {
    name: "portfolio/shareholder-all",
    path: "/portfolio/all/shareholder/:shareholderId/:activeTab",
  },
  {
    name: "portfolio/shareholder-instance",
    path: "/portfolio/:portfolioId/shareholder/:shareholderId/:activeTab",
  },
  {
    name: "portfolio/shareholder-admin",
    path: "/portfolio/admin/shareholder/:shareholderId/:activeTab",
  },
  {
    name: "portfolio/shareholder-board-member",
    path: "/portfolio/board_member/shareholder/:shareholderId/:activeTab",
  },
  {
    name: "portfolio/contacts-admins-all",
    path: "/portfolio/all/contacts/admins/:externalId",
  },
  {
    name: "portfolio/contacts-admins-admin",
    path: "/portfolio/admin/contacts/admins/:externalId",
  },
  {
    name: "portfolio/contacts-admins-instance",
    path: "/portfolio/:portfolioId/contacts/admins/:externalId",
  },
  {
    name: "portfolio/contacts/custom-role",
    path: "/portfolio/all/contacts/custom-role/:customRoleId",
  },
  {
    name: "portfolio/contacts-admins/custom-role",
    path: "/portfolio/admin/contacts/custom-role/:customRoleId",
  },
  {
    name: "portfolio/contacts-instance/custom-role",
    path: "/portfolio/:portfolioId/contacts/custom-role/:customRoleId",
  },
  {
    name: "portfolio/custom-role-details",
    path: "/portfolio/all/contacts/custom-role/:customRoleId/details/:externalId",
  },
  {
    name: "portfolio-admins/custom-role-details",
    path: "/portfolio/admin/contacts/custom-role/:customRoleId/details/:externalId",
  },
  {
    name: "portfolio-instance/custom-role-details",
    path: "/portfolio/:portfolioId/contacts/custom-role/:customRoleId/details/:externalId",
  },
  {
    name: "portfolio/signatures-all",
    path: "/portfolio/all/signatures/:signaturesTab?",
    redirectTo: "/portfolio/all/follow-up/signatures/",
  },
  {
    name: "invitation-request",
    path: "/invitation-request/:invitationRequestId",
  },
  {
    name: "batch-invitation-request",
    path: "/batch-invitation-request/:batchId",
  },
  {
    name: "user/settings",
    path: "/user/settings",
    data: { allowShareholder: true },
  },
  {
    name: "signing",
    path: "/signing/:signingMethod",
  },
  {
    name: "notice-for-shareholder",
    path: "/notice-general-meeting/resolve/:documentId",
    data: { allowShareholder: true },
  },
  {
    name: "enterprise-account",
    path: "/enterprise-account/:id",
  },
] as const satisfies Route<DCRouteData>[];

export const anonymousRoutes = [
  {
    name: "login",
    path: "/login",
    data: { allowAnonymous: true },
  },
  {
    name: "login-sweden",
    path: "/login-sweden",
    data: { allowAnonymous: true },
  },
  {
    name: "login-callback",
    path: "/login-callback",
    data: { allowAnonymous: true },
  },
  {
    name: "signing-completed-bankid-callback",
    path: "/signing-completed-bankid-callback",
    data: { allowAnonymous: true },
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    data: { allowAnonymous: true },
  },
  {
    name: "sign",
    path: "/sign",
    data: { allowAnonymous: true },
  },
  {
    name: "subscription-form",
    path: "/subscription-form",
    data: { allowAnonymous: true },
  },
  {
    name: "notice-board-meeting",
    path: "/notice-board-meeting/:noticeDocumentId",
    data: { allowAnonymous: true },
  },
  {
    name: "board-minutes-review/matter",
    path: "/board-minutes-review/:meetingEmailId/matter/:matterId?",
    data: { allowAnonymous: true },
  },
  {
    name: "board-minutes-review",
    path: "/board-minutes-review/:meetingEmailId",
    data: { allowAnonymous: true },
  },
  {
    name: "notice-genera-meeting/poa-recipient",
    path: "/notice-general-meeting-poa-recipient/:powerOfAttorneyRecipientId/:tab?/:matter?",
    data: { allowAnonymous: true },
  },
  {
    name: "notice-general-meeting",
    path: "/notice-general-meeting/:noticeToGeneralMeetingId/:tab?/:matter?",
    data: { allowAnonymous: true },
  },
  {
    name: "create-password",
    path: "/user/create-password",
    data: { allowAnonymous: true },
  },
  {
    name: "invitation",
    path: "/invitation/:invitationId/:invitationToken",
    data: { allowAnonymous: true },
  },
  {
    name: "batch-invitation",
    path: "/batch-invitation/:batchInvitationId/:invitationToken",
    data: { allowAnonymous: true },
  },
  {
    name: "affiliate",
    path: "/affiliate/:affiliateKey",
    data: { allowAnonymous: true },
  },
  {
    name: "document-for-viewing",
    path: "/document/view/:documentId",
    data: { allowAnonymous: true },
  },
] as const satisfies Route<DCRouteData>[];

export const routes = [
  ...boardMemberRoutes,
  ...shareholderRoutes,
  ...adminRoutes,
  ...superadminRoutes,
  ...storiesRoutes,
  ...userRoutes,
  ...anonymousRoutes,
] as const satisfies Route<DCRouteData>[];

export type BoardMemberRoute = (typeof boardMemberRoutes)[number];
export type ShareholderRoute = (typeof shareholderRoutes)[number];
export type AdminRoute = (typeof adminRoutes)[number];
export type SuperadminRoute = (typeof superadminRoutes)[number];
export type StoriesRoute = (typeof storiesRoutes)[number];
export type UserRoute = (typeof userRoutes)[number];
export type AnonymousRoute = (typeof anonymousRoutes)[number];
export type DCRoute = (typeof routes)[number] & { data?: DCRouteData };

export type MatchedDCRoute<R extends DCRoute = DCRoute> = MatchedRoute<DCRouteData, R>;

export const isBoardMemberRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<BoardMemberRoute> => route?.name.startsWith("board-member/") === true;

export const isShareholderRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<ShareholderRoute> => route?.name.startsWith("shareholder/") === true;

export const isAdminRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<AdminRoute> => route?.name.startsWith("admin/") === true;

export const isSuperadminRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<SuperadminRoute> => route?.name.startsWith("superadmin") === true;

export const isStoriesRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<StoriesRoute> => route?.name.startsWith("stories") === true;

export const isUserRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<UserRoute> => userRoutes.some((r) => r.name === route?.name);

export const isAnonymousRoute = (
  route: MatchedDCRoute | undefined,
): route is MatchedDCRoute<AnonymousRoute> => anonymousRoutes.some((r) => r.name === route?.name);
